module.exports = __webpack_public_path__ + "img/db-5.5a66ea28.png";